export const exportTranslations = {
  fileIsCurrentlyBeingGenerated: "File is currently being generated",
  removeFromList: "Remove from list",
  yourReportIsBeingGenerated: "Your report is currently being generated",
  largeReportsMayTakeSeveralMinutes:
    "Large reports may take several minutes to generate.",
  reportCurrentlyBeingGenerated:
    "A report with the current filters is already being generated. To generate a new report, change or add filters first.",
  reportAlreadyGeneratingConfirmation:
    "A report for this class is currently being generated — do you want to generate another one?",
  removeReport: "Remove report",
}
